/*@ngInject*/
const RowRepeaterUtil = function (formComponentUtil, formViewerUtil, formatUtil, appTypeConfigurationModel, fieldType, rowRepeaterRowListComparisonResultConstant) {

    this.processCollapsibleColumnsAndVisibility = function (rowRepeaterId, rowRepeaterMap) {
        let rowRepeater = rowRepeaterMap[rowRepeaterId],
            columnList = {},
            variableName,
            totalVisibleRows,
            rowHiddenForUserType = appTypeConfigurationModel.isUnderwriterWorkstation() ? !rowRepeater.rowTemplate.repeaterField.fieldTemplate.carrierVisible : !rowRepeater.rowTemplate.repeaterField.fieldTemplate.agencyVisible;

        if (_.size(rowRepeater.rowList) !== 0) {
            _.each(rowRepeater.rowList[0].fieldStructureList, function (fieldStructure) {
                variableName = fieldStructure.uiField.fieldTemplate.variableName;
                columnList[variableName] = true;
            });

            _.each(rowRepeater.rowList, function (row) {
                _.each(row.fieldStructureList, function (fieldStructure) {

                    if (!formComponentUtil.isFieldHidden(fieldStructure.fieldModel, fieldStructure.uiField.fieldTemplate)) {
                        variableName = fieldStructure.uiField.fieldTemplate.variableName;
                        columnList[variableName] = false;
                    }
                });
            });

            _.each(rowRepeater.rowList, function (row) {
                _.each(row.fieldStructureList, function (fieldStructure) {
                    variableName = fieldStructure.uiField.fieldTemplate.variableName;
                    fieldStructure.columnName = variableName;
                    fieldStructure.isColumnCollapsed = columnList[variableName];
                });
            });
        }

        totalVisibleRows = _.filter(columnList, function (item) {
            return item === false;
        }).length;

        rowRepeater.isHidden = rowRepeater.configurable ? false : rowHiddenForUserType || totalVisibleRows === 1;
    };

    this.processRemoteRowAddition = function (rowTemplateId, rowInstance, rowRepeaterMap, fieldMap, rootFormId) {
        let rowRepeater = rowRepeaterMap[rowTemplateId],
            rowRepeaterId = rowInstance.uiRowId,
            parentForm = rowRepeaterMap[rowRepeaterId].parentForm;

        var buildFieldStructureList = (rowFields, rowInstanceId) => {
            let fieldStructureList = [],
                fieldStructure;

            let previousFieldKey = null;
            let previousRow = rowRepeater.rowList[rowRepeater.rowList.length - 1];
            if (previousRow) {
              previousFieldKey = formViewerUtil.findLastFieldInPreviousRowKey(previousRow);
            }
            _.each(rowFields, (uiField) => {
                fieldStructure = {
                    isRowRepeaterField: true,
                    fieldStructureId: rootFormId + '-' + uiField.fieldTemplate.id + '-' + rowInstance.id,
                    rootFormId: rootFormId,
                    parentForm: parentForm,
                    uiField: uiField,
                    fieldModel: undefined,
                    rowNumber: rowInstance.rowNumber,
                    rowInstanceId: rowInstanceId,
                    rowRepeaterId: rowRepeaterId,
                    rowRepeaterName: this.getRowRepeaterName(rowRepeater.rowTemplate.repeaterField),
                    rowRepeaterModel: rowInstance,
                    rowRepeaterTemplate: rowRepeater.rowTemplate,
                    indexedName: formComponentUtil.getIndexedFieldName(uiField, true, rowInstance)
                };
                formComponentUtil.setupFieldProperties(fieldStructure);
                fieldStructureList.push(fieldStructure);
                let fieldKey = rootFormId + '-' + uiField.fieldTemplate.id + '-' + rowInstanceId;
                if (previousFieldKey) {
                    fieldMap.putAfter(previousFieldKey, fieldKey, fieldStructure);
                }
                else {
                    fieldMap.put(fieldKey, fieldStructure);
                }
                previousFieldKey = fieldKey;
            });

            return fieldStructureList;
        };

        // If the server creates a row and we already have a placeholder row, replace with the server representation
        if (rowInstance.rowNumber === 0 && rowRepeater.rowList.length > 0) {
            rowRepeater.rowList[0].parentForm = parentForm;
            rowRepeater.rowList[0].rowTemplate = rowRepeater.rowTemplate;
            rowRepeater.rowList[0].rowModel = rowInstance;
            rowRepeater.rowList[0].fieldStructureList = buildFieldStructureList(rowRepeater.rowTemplate.fields, rowInstance.id);
        } else {
            rowRepeater.rowList.push({
                parentForm: parentForm,
                rowTemplate: rowRepeater.rowTemplate,
                rowModel: rowInstance,
                fieldStructureList: buildFieldStructureList(rowRepeater.rowTemplate.fields, rowInstance.id)
            });
        }

        this.processCollapsibleColumnsAndVisibility(rowRepeaterId, rowRepeaterMap);
        rowRepeater.timeLastModified = new Date().getTime();
    };

    this.processRemoteRowUpdate = function (rowTemplateId, rowInstance, rowRepeaterMap) {
        let rowRepeaterId = rowTemplateId,
            rowRepeater = rowRepeaterMap[rowRepeaterId],
            rowList = rowRepeater.rowList;

        _.each(rowList, function (row) {

            if (row.rowModel.id === rowInstance.id) {
                row.rowModel = _.clone(rowInstance);

                _.each(row.fieldStructureList, function (fieldStructure) {
                    let fieldName;

                    fieldStructure.rowNumber = row.rowModel.rowNumber;
                    fieldStructure.indexedName = formComponentUtil.getIndexedFieldName(fieldStructure.uiField, true, row.rowModel);

                    if (!_.isNil(fieldStructure.fieldModel)) {
                        fieldName = fieldStructure.fieldModel.baseName;

                        if (fieldStructure.rowNumber > 0) {
                            fieldName += ':' + fieldStructure.rowNumber;
                        }

                        fieldStructure.fieldModel.name = fieldName;
                        fieldStructure.fieldModel.index = fieldStructure.rowNumber;
                    }
                });
            }
        });
    };

    this.processRemoteRowDeletion = function (message, rowRepeaterMap, fieldMap) {
        let rowRepeaterId = message.uiRowId,
            rowRepeater = rowRepeaterMap[rowRepeaterId];

        _.each(rowRepeater.rowList, function (row, index) {
            if (row.rowModel.id === message.id) {
                _.eachRight(row.fieldStructureList, function (fieldStructure) {
                    fieldMap.remove(fieldStructure.fieldStructureId);
                });
                rowRepeater.rowList.splice(index, 1);
                return false;
            }
        });

        this.processCollapsibleColumnsAndVisibility(rowRepeaterId, rowRepeaterMap);
        rowRepeater.timeLastModified = new Date().getTime();
    };

    this.sortRowRepeater = function (rowRepeaterId, sortKey, sortType, rowRepeaterMap) {
        let rowRepeater = rowRepeaterMap[rowRepeaterId];

        rowRepeater.sort = {
            sortKey: sortKey,
            sortType: sortType
        };

        rowRepeater.rowList = _.sortBy(rowRepeater.rowList, function (row) {
            let fieldStructure = _.find(row.fieldStructureList, function (fieldStructure) {
                    return fieldStructure.uiField.fieldTemplate.variableName === rowRepeater.sort.sortKey;
                }) || {},
                validator,
                numericValidatorList = ['number', 'currency', 'number range', 'percent', 'number with commas', 'year', 'vehicle year'],
                result = '';

            if (sortKey === 'rowNumber') {
                result = row.rowModel.rowNumber;
            } else if (fieldStructure.uiField.fieldTemplate.type === fieldType.CLASSCODEFINDER){
                result = fieldStructure.fieldModel.value;
            } else if (fieldStructure.fieldModel) {
                validator = fieldStructure.uiField.fieldTemplate.validator;
                if (numericValidatorList.indexOf(validator) !== -1) {
                    result = parseFloat(fieldStructure.fieldModel.value);
                } else if (fieldStructure.fieldModel.valueLabel) {
                    result = fieldStructure.fieldModel.valueLabel;
                } else {
                    result = fieldStructure.fieldModel.value;
                }
            }

            return result;
        });

        if (rowRepeater.sort.sortType === 'desc') {
            rowRepeater.rowList = rowRepeater.rowList.reverse();
        }

        rowRepeater.timeLastModified = new Date().getTime();
    };

    this.getRowRepeaterName = function (fieldStructure) {
        return `rowRepeater-${formatUtil.formatAsSelector(fieldStructure.fieldTemplate.variableName)}`;
    };

    this.compareRowLists = function (rowList1, rowList2) {
        let rowRepeaterRowListComparisonResult = rowRepeaterRowListComparisonResultConstant.EQUAL;

        const rowList1Length = _.size(rowList1);
        const rowList2Length = _.size(rowList2);

        let numberOfRowsAdded = 0;
        _.each(rowList1, function (row, index) {
            // If the row we are comparing doesn't have an equivalent row in the second list, we have added a new row to the list
            if (index >= rowList2Length) {
                numberOfRowsAdded++;
            } else {
                // If the the row we are comparing and the equivalent row in the second list DO NOT have matching IDs, the contents of the list have changed
                if (rowList2[index].rowModel.id !== row.rowModel.id) {
                    rowRepeaterRowListComparisonResult = rowRepeaterRowListComparisonResultConstant.CONTENTS_CHANGED;
                    return false;
                }
            }
        });

        if (rowRepeaterRowListComparisonResult !== rowRepeaterRowListComparisonResultConstant.CONTENTS_CHANGED) {
            if (numberOfRowsAdded === 1) {
                rowRepeaterRowListComparisonResult = rowRepeaterRowListComparisonResultConstant.ONE_ROW_ADDED;
            } else if (numberOfRowsAdded > 1) {
                rowRepeaterRowListComparisonResult = rowRepeaterRowListComparisonResultConstant.MORE_THAN_ONE_ROW_ADDED;
            } else if (rowList1Length < rowList2Length) {
                rowRepeaterRowListComparisonResult = rowRepeaterRowListComparisonResultConstant.ROWS_REMOVED;
            }
        }

        return rowRepeaterRowListComparisonResult;
    };
};

angular.module('umFormViewer')
    .service('rowRepeaterUtil', RowRepeaterUtil);
